export { default } from './EventCover';